import React, { useRef, useState } from "react";
import { Paperclip, Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { formatError } from "../../lib/api.js";
import { uploadBpsFile, openAttachment, CATEGORY_LABELS } from "../../lib/bps.js";
import { fmtDateTime } from "../../lib/format.js";

// Upload + list of BPS attachments of one category.
export const BpsAttachmentSlot = ({ bpsId, category, label, required = false, attachments = [], onUploaded, multiple = false, accept, since }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const files = attachments.filter((a) => a.category === category && (!since || a.uploaded_at >= since));

  const onPick = async (e) => {
    const picked = Array.from(e.target.files || []);
    e.target.value = "";
    if (!picked.length) return;
    setBusy(true);
    try {
      const uploaded = [];
      for (const f of picked) uploaded.push(await uploadBpsFile(bpsId, f, category));
      toast.success(`${CATEGORY_LABELS[category] || "Anexo"} anexado`);
      onUploaded?.(uploaded);
    } catch (err) {
      toast.error(formatError(err?.response?.data?.detail, "Falha ao anexar ficheiro"));
    } finally {
      setBusy(false);
    }
  };

  const missing = required && files.length === 0;
  return (
    <div className={`border rounded-sm p-2.5 ${missing ? "border-[#DC3545]/50 bg-[#FDF2F2]" : "border-gray-200 bg-[#FAFBFC]"}`} data-testid={`bps-slot-${category}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs font-semibold text-[#1A1A2E] flex items-center gap-1.5">
          <Paperclip className="w-3.5 h-3.5 text-[#1F3864]" />
          {label || CATEGORY_LABELS[category]}
          {required ? <span className="text-[#DC3545]" data-testid={`bps-slot-${category}-required`}>* obrigatório</span> : <span className="text-[#6C757D] font-normal">(opcional)</span>}
        </div>
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="text-[11px] border border-[#1F3864] text-[#1F3864] hover:bg-[#1F3864] hover:text-white rounded-sm px-2 py-1 flex items-center gap-1 transition-colors disabled:opacity-60" data-testid={`bps-slot-${category}-upload`}>
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Upload className="w-3 h-3" />} Anexar
        </button>
        <input ref={ref} type="file" hidden multiple={multiple} accept={accept} onChange={onPick} data-testid={`bps-slot-${category}-input`} />
      </div>
      {files.length > 0 && (
        <ul className="mt-2 space-y-1">
          {files.map((a) => (
            <li key={a.id} className="text-xs flex items-center justify-between gap-2" data-testid={`bps-attachment-${a.id}`}>
              <button type="button" onClick={() => openAttachment(a)} className="text-[#1F3864] hover:underline truncate text-left">{a.original_filename}</button>
              <span className="text-[#6C757D] shrink-0">{a.uploaded_by_name} · {fmtDateTime(a.uploaded_at)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
